/**
 * @generated SignedSource<<82807e4b9eaa774504cd473814baef53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductLinkedTodosQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
};
export type ProductLinkedTodosQuery$data = {
  readonly storeProduct: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductLinkedTodos_StoreProduct">;
  } | null;
};
export type ProductLinkedTodosQuery = {
  response: ProductLinkedTodosQuery$data;
  variables: ProductLinkedTodosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v8/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v4/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v15/*: any*/),
    (v14/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  (v11/*: any*/),
  (v4/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v23 = [
  (v20/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductLinkedTodosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductLinkedTodos_StoreProduct"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductLinkedTodosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "TodoConnection",
            "kind": "LinkedField",
            "name": "todos",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Todo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ordinal",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "response",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "type": "TodoResponseImage",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canWrite",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOrg",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedBody",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canChangeStatus",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isIssue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoContact",
                        "kind": "LinkedField",
                        "name": "contact",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feedbackStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AssignedEmployee",
                        "kind": "LinkedField",
                        "name": "assigned",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assignedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Employee",
                            "kind": "LinkedField",
                            "name": "employee",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AssignedRole",
                        "kind": "LinkedField",
                        "name": "assignedRoles",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "employeeIds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "team",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Employee",
                                "kind": "LinkedField",
                                "name": "employees",
                                "plural": true,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "expireAtDate",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategoryTag",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProduct",
                        "kind": "LinkedField",
                        "name": "linkedProducts",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Todo",
                        "kind": "LinkedField",
                        "name": "subTodos",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expireAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isResponseCompleted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "resolvedAtDate",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "lastChangedStatusByActor",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreUser",
                                "kind": "LinkedField",
                                "name": "storeUser",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserActor",
                            "abstractKey": null
                          },
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "GroupActor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "ConnectActor",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "createdAtDate",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeToResolvedFormatted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoSubject",
                        "kind": "LinkedField",
                        "name": "subject",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoSubjectBreadcrumb",
                            "kind": "LinkedField",
                            "name": "allBreadcrumbs",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requiredToDescribeTodo",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "iconUri",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "createdByActor",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreUser",
                                "kind": "LinkedField",
                                "name": "storeUser",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrgDescription",
                                        "kind": "LinkedField",
                                        "name": "orgDescription",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "orgIconUri",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserActor",
                            "abstractKey": null
                          },
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Employee",
                                "kind": "LinkedField",
                                "name": "employee",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v4/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "GroupActor",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              (v24/*: any*/)
                            ],
                            "type": "ConnectActor",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ProductLinkedTodos_store_todos",
            "kind": "LinkedHandle",
            "name": "todos"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ada5b3f069a9c887f7055ff773ae2c15",
    "id": null,
    "metadata": {},
    "name": "ProductLinkedTodosQuery",
    "operationKind": "query",
    "text": "query ProductLinkedTodosQuery(\n  $id: ID!\n  $first: Int!\n  $after: String\n) {\n  storeProduct(id: $id) {\n    id\n    ...ProductLinkedTodos_StoreProduct\n  }\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment CreatedBySubject_actor on Actor {\n  __isActor: __typename\n  ...SignedActorCompact_actor\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment ProductLinkedTodos_StoreProduct on StoreProduct {\n  todos(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ordinal\n        ...TodoListItem_todo\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TodoCircleStatusWithResponse_todo on Todo {\n  id\n  expireAt\n  status\n  canChangeStatus\n  canWrite\n  ordinal\n  isResponseCompleted\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n  }\n}\n\nfragment TodoListItemAssignedUsers_todo on Todo {\n  assigned {\n    assignedAt\n    employee {\n      id\n      ...ListItemAssignees_employees\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoListItemContact_todo on Todo {\n  contact {\n    name\n    phoneNumber\n    email\n  }\n  feedbackStatus\n}\n\nfragment TodoListItemFooterDone_todo on Todo {\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n}\n\nfragment TodoListItemFooterPending_todo on Todo {\n  ...TodoListItemAssignedUsers_todo\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n  expireAtDate {\n    ...StoreFormattedDate\n    isoString\n  }\n  tags {\n    ...TodoListItemTags_tag\n  }\n  assigned {\n    __typename\n    id\n  }\n  assignedRoles {\n    __typename\n    id\n  }\n  linkedProducts {\n    ...TodoListItemProducts_StoreProduct\n    id\n  }\n  ...TodoListItemFooterSubTodos_todo\n  subTodos {\n    __typename\n    id\n  }\n  commentCount\n}\n\nfragment TodoListItemFooterSubTodos_todo on Todo {\n  id\n  subTodos {\n    status\n    id\n  }\n}\n\nfragment TodoListItemFooter_todo on Todo {\n  ...TodoListItemFooterDone_todo\n  ...TodoListItemFooterPending_todo\n  status\n}\n\nfragment TodoListItemHeaderWrapper_todo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  timeToResolvedFormatted\n}\n\nfragment TodoListItemHeader_todo on Todo {\n  ...TodoListItemHeaderWrapper_todo\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n  title\n  isIssue\n  createdByActor {\n    __typename\n    ...CreatedBySubject_actor\n  }\n}\n\nfragment TodoListItemMainContentDetails_todo on Todo {\n  ...TodoListItemCompletedInfo_todo\n  status\n  images {\n    id\n    ...Image_image\n  }\n  linkedProducts {\n    imageUrl\n    id\n  }\n}\n\nfragment TodoListItemMainContentText_todo on Todo {\n  title\n  isIssue\n  status\n}\n\nfragment TodoListItemPriority_todo on Todo {\n  priority\n  status\n}\n\nfragment TodoListItemProducts_StoreProduct on StoreProduct {\n  name\n}\n\nfragment TodoListItemTags_tag on TodoCategoryTag {\n  id\n  color\n  title\n}\n\nfragment TodoListItem_todo on Todo {\n  id\n  status\n  ordinal\n  response {\n    __typename\n  }\n  canWrite\n  isOrg\n  body\n  formattedBody\n  canChangeStatus\n  ...TodoListItemMainContentText_todo\n  ...TodoListItemPriority_todo\n  ...TodoListItemFooter_todo\n  ...TodoCircleStatusWithResponse_todo\n  ...TodoListItemMainContentDetails_todo\n  ...TodoListItemHeader_todo\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n"
  }
};
})();

(node as any).hash = "fcddf94a558eea148899a76a41109f5d";

export default node;
